import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import facultyData from "../UG/facultyData/eceFacultyData";

export const programme = {
  id: "ece-research",
  name: "Electronics & Communication Engineering Research Centre",
  short: "E&CE Research Centre",
  programmeType: "research",
  programmeLabel: "Research Centre",
  duration: "Ph.D. Programme",
  established: "2012",
  facultyData,
  hideFacultySection: true,
  hideSharedClubs: true,

  description:
    "The Department of Electronics and Communication Engineering is a VTU-recognized Research Centre since the academic year 2012. The centre offers Ph.D. programmes and actively promotes research, innovation, publications, project proposal development, and interdisciplinary problem-solving through advanced research facilities and faculty expertise.",

  image:
    "/HomePage/dept/ece.jpeg",

  labs: [
    "VLSI Design Lab",
    "Embedded Systems Lab",
    "FPGA Development Lab",
    "Data Acquisition Facilities",
    "Simulation & Computing Lab",
  ],

  dashboard: [
    ["Recognized Since", "2011-12"],
    ["Research Areas", "04"],
    ["Research Supervisors", "02"],
    ["Research Scholars", "08"],
  ],

  quickFacts: [
    ["Established", "2011-12"],
    ["Programme", "Ph.D."],
    ["Research Supervisors", "02"],
    ["Research Scholars", "08"],
    ["Research Areas", "Wireless Sensor Networks, Image Processing, MEMS, VLSI Design"],
    ["Carpet Area", "66 m2"],
    ["Investment", "15.43 Lakhs"],
    ["Affiliation", "VTU, Belagavi"],
  ],

  academicOverview: [
    {
      title: "Research Objectives",
      text:"The Research and Development Cell fosters innovation and research excellence by promoting research projects, securing funding, encouraging scholarly publications, organizing academic events, and supporting the complete research process from design and simulation to experimentation, analysis, and dissemination of outcomes.",
    },
    {
      title: "Research Facilities",
      text:
        "The research centre is equipped with modern computing resources, embedded platforms, FPGA development boards, data acquisition systems, simulation software, and VLSI design tools to support advanced research activities.",
    },
    {
      title: "Research Culture",
      text:
        "Faculty members and scholars actively contribute to research in emerging areas of electronics and communication engineering through publications, funded projects, technical collaborations, and doctoral research activities.",
    },
  ],

  curriculumSupport: [
    "Advanced research methodology training",
    "Publication and patent support",
    "Proposal writing and funding guidance",
    "Simulation and prototype development",
    "Industry-oriented research activities",
    "Interdisciplinary research collaborations",
    "Seminars, workshops, and technical talks",
    "Ph.D. research supervision",
  ],

  researchAreas: [
    "Wireless Sensor Networks",
    "Image Processing",
    "MEMS",
    "VLSI Design",
  ],

  infrastructureTable: {
    columns: ["Carpet Area in m2", "Major Equipments", "Investment in Lakhs"],
    rows: [
      [
        "66",
        "Computer Systems, ARM Cortex Board, Data Acquisition Module, PIC Microcontroller Kit, Spartan-3e FPGA 100K Evaluation Board, Raspberrypi2 Module, IC Tester, Power Supply, Signal Generators, Code Blocks, MATLAB Software and Cadence University Bundle Analog & Digital Front End and Back End",
        "15.43",
      ],
    ],
  },

  infrastructureTable: {
    columns: ["Carpet Area in m2", "Major Equipments", "Investment in Lakhs"],
    rows: [[
      "66",
      "Computer Systems, ARM Cortex Board, Data Acquisition Module, PIC Microcontroller Kit, Spartan-3e FPGA 100K Evaluation Board, Raspberrypi2 Module, IC Tester, Power Supply, Signal Generators, Code Blocks, MATLAB Software and Cadence University Bundle Analog & Digital Front End and Back End",
      "15.43",
    ]],
  },

  achievements: [
    "Recognized as a VTU Research Centre in 2011-12.",
    "Offers Ph.D. programme in Electronics and Communication Engineering.",
    "Active faculty involvement in research and scholarly publications.",
    "Research support in VLSI, MEMS, Image Processing, and Wireless Sensor Networks.",
  ],

  supervisors: [
    ["Dr. Arun L. Kakhandki", "Professor", "f-arun-l-kakhandki", "/FacultyCImages/Arun L. Kakhandki.png"],
    ["Dr. Mahendra M. Dixit", "Professor", "f-mahendra-m-dixit"],
  ],

  researchScholars: [
    ["Mr. Deepak Sharma", "Assistant Professor", "f-deepak-sharma"],
    ["Ms. Pooja C. Shinde", "Assistant Professor", "f-pooja-c-shindhe"],
    ["Ms. Pavithra Badiger", "Assistant Professor", "f-pavitra-m-badiger"],
    ["Mrs. Rajeshwari A. Pashupatimath", "Assistant Professor", "f-rajeshwari-pashupatimath"],
    ["Mr. Shridhar Reddy Karra", "Assistant Professor", null, "/FacultyCImages/Shridhar_Reddy_Karra.png"],
    ["Mr. Shivaling M. Hunagund", "Assistant Professor", null, "/FacultyCImages/Shivaling_M_Hunagund.png"],
    ["Mr. Sushant Jadhav", "Assistant Professor", null, "/FacultyCImages/Mr.Sushant Jadhav.png"],
    ["Mr. Suraj Kadli", "Assistant Professor", "f-suraj-kadli"],
  ],
};

const ResearchECE = () => <ProgrammeDetail programme={programme} />;

export default ResearchECE;
